import { render, staticRenderFns } from "./mall_diamond.vue?vue&type=template&id=2d2b922e&scoped=true"
import script from "./mall_diamond.vue?vue&type=script&lang=ts"
export * from "./mall_diamond.vue?vue&type=script&lang=ts"
import style0 from "./mall_diamond.vue?vue&type=style&index=0&id=2d2b922e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b922e",
  null
  
)

export default component.exports